import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchCustomerList_api = async (
  id: string | null = null,
  page = 1,
  limit = 10,
  filters: any = {},
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Customers/fetch_customerList_with_inquiryData.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          id: id || null,
          page,
          limit,
          ...filters,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch customer list with inquiry data failed:", error);
    return { error: "Fetch customer list with inquiry data failed" };
  }
};
